import { faClose } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  Box,
  Drawer,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
} from '@mui/material'
import { useTheme } from '@mui/system'
import { useTranslation } from 'next-i18next'
import COLORS from '../../../styles/colors'
import { MonitoredReading } from '../hooks/useLiveCallMonitorData'
import LiveCallMonitorEmptyState from './LiveCallMonitorEmptyState'
import LiveCallMonitorItem from './LiveCallMonitorItem'

export type LiveCallMonitorDrawerProps = {
  open: boolean
  onClose: () => void
  readings: MonitoredReading[]
  nextReadingStart?: Date
}

const LiveCallMonitorDrawer = ({
  open,
  onClose,
  readings,
  nextReadingStart,
}: LiveCallMonitorDrawerProps) => {
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'))
  const { t } = useTranslation('LiveCallMonitor')

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        role: 'dialog',
        'aria-modal': true,
        'aria-label': t('region') as string,
        style: {
          marginTop: isSmall ? 0 : '100px',
          marginRight: isSmall ? 0 : '20px',
          height: '85%',
          maxHeight: '930px',
          left: isSmall ? 0 : 'auto',
          position: isSmall ? 'absolute' : 'fixed',
          width: isSmall ? '100vw' : '460px',
        },
      }}
      BackdropProps={{
        style: {
          width: '100vw',
          height: '100vh',
        },
      }}
    >
      <Stack
        height="100%"
        width="100%"
        sx={{ background: COLORS.backgroundGreyLight }}
      >
        <Box
          py="20px"
          px="25px"
          borderRadius="8px"
          sx={{ backgroundColor: COLORS.burnedOrange }}
        >
          <Stack alignItems="center" direction="row">
            <Box flexGrow={1}>
              <Typography
                color={COLORS.white}
                component="h2"
                textTransform="uppercase"
                variant="chatHeaderTitleUser"
              >
                {t('title')}
              </Typography>
            </Box>
            <IconButton aria-label={t('close') as string} onClick={onClose}>
              <FontAwesomeIcon
                aria-hidden="true"
                color={COLORS.white}
                icon={faClose}
              />
            </IconButton>
          </Stack>
        </Box>
        <Box flexGrow={1} sx={{ overflowY: 'auto' }}>
          <Stack spacing="12px" p="16px">
            {readings.length > 0 ? (
              readings.map((reading) => (
                <LiveCallMonitorItem key={reading.id} reading={reading} />
              ))
            ) : (
              <LiveCallMonitorEmptyState nextReadingStart={nextReadingStart} />
            )}
          </Stack>
        </Box>
      </Stack>
    </Drawer>
  )
}

export default LiveCallMonitorDrawer
